import React from "react";

export default function MentionsLegales() {
  return (
    <div style={{ maxWidth: "800px", margin: "80px auto", padding: "0 20px", fontFamily: "Manrope, sans-serif", color: "#1a1a1a", lineHeight: "1.8" }}>
      <h1 style={{ fontSize: "2rem", fontWeight: "800", marginBottom: "40px" }}>Mentions Légales</h1>

      <h2 style={{ fontSize: "1.2rem", fontWeight: "700", marginTop: "32px" }}>1. Éditeur du site</h2>
      <p>
        <strong>Raison sociale :</strong> ALTER ENERGIES<br />
        <strong>Propriétaire :</strong> François Delattre<br />
        <strong>Adresse :</strong> 1899 Côte de Pinel Garrigou, 47380 Pinel-Hauterive<br />
        <strong>Téléphone :</strong> 06 28 51 49 15<br />
        <strong>Email :</strong> frs.delattre@gmail.com<br />
        <strong>SIRET :</strong> 788 886 521 00012<br />
        <strong>Certification :</strong> RGE QualiPAC
      </p>

      <h2 style={{ fontSize: "1.2rem", fontWeight: "700", marginTop: "32px" }}>2. Hébergement</h2>
      <p>
        Ce site est hébergé par :<br />
        <strong>Vercel Inc.</strong><br />
        340 Pine Street, Suite 701, San Francisco, CA 94104, États-Unis<br />
        Site : <a href="https://vercel.com" target="_blank" rel="noreferrer">vercel.com</a>
      </p>

      <h2 style={{ fontSize: "1.2rem", fontWeight: "700", marginTop: "32px" }}>3. Propriété intellectuelle</h2>
      <p>
        L'ensemble du contenu de ce site (textes, images, logos) est la propriété exclusive d'ALTER ENERGIES. Toute reproduction, même partielle, est interdite sans autorisation écrite préalable.
      </p>

      <h2 style={{ fontSize: "1.2rem", fontWeight: "700", marginTop: "32px" }}>4. Responsabilité</h2>
      <p>
        ALTER ENERGIES s'efforce de maintenir les informations de ce site à jour et exactes. Cependant, nous ne pouvons garantir l'exactitude, la complétude ou l'actualité des informations diffusées.
      </p>

      <h2 style={{ fontSize: "1.2rem", fontWeight: "700", marginTop: "32px" }}>5. Droit applicable</h2>
      <p>
        Le présent site est soumis au droit français. En cas de litige, les tribunaux français seront seuls compétents.
      </p>
    </div>
  );
}
